import React, { useMemo } from 'react';
import { PartializedLoadViewModel } from '../../services/api/flightChanges/types';
import { PartializedLoadAccordion } from './PartializedLoadAccordion';
import * as S from './styles/PartializedLoad.style';

export interface PartializedLoadsListProps {
    loads: PartializedLoadViewModel[];
    variant?: 'previous' | 'new';
}

const PartializedLoadsListComponent: React.FC<PartializedLoadsListProps> = ({ loads, variant = 'new' }) => {
    const sortedLoads = useMemo(() => {
        return [...loads].sort((a, b) => a.partNumber - b.partNumber);
    }, [loads]);

    return (
        <S.PartializedLoadsList role="list" aria-label="Partialized loads">
            {sortedLoads.map((load) => (
                <PartializedLoadAccordion
                    key={`partial-load-${load.partNumber}`}
                    load={load}
                    defaultExpanded={true}
                    variant={variant}
                />
            ))}
        </S.PartializedLoadsList>
    );
};

export const PartializedLoadsList = React.memo(
    PartializedLoadsListComponent,
    (prevProps, nextProps) => {
        if (prevProps.loads.length !== nextProps.loads.length) {
            return false;
        }

        if (prevProps.variant !== nextProps.variant) {
            return false;
        }

        return prevProps.loads.every((prevLoad, index) => {
            const nextLoad = nextProps.loads[index];
            return (
                prevLoad.partNumber === nextLoad.partNumber &&
                prevLoad.piecesCount === nextLoad.piecesCount &&
                prevLoad.segments.length === nextLoad.segments.length &&
                prevLoad.segments.every((prevSegment, segIndex) => {
                    const nextSegment = nextLoad.segments[segIndex];
                    return prevSegment?.flightNumber === nextSegment?.flightNumber &&
                        prevSegment?.leg === nextSegment?.leg;
                })
            );
        });
    }
);

